export const APP_NAME = 'identification_perseus';

export const ROLLOUTS = {
    LYNXES_IDENTIFICATION_RESET_PASSWORD_STEP: 'lynxes_identification_core_reset_password_flow',
    LYNXES_IDENTIFICATION_ILLUSTRATION_RIGHT: 'lynxes_identification_illustration_right',
    BEETLES_MIGRATE_SIGNUP_WEB: 'beetles_migrate_signup_web',
    BEETLES_MIGRATE_SIGNIN_WEB: 'beetles_migrate_signin_web',
    BEETLES_MIGRATE_SOCIAL_SIGNUP: 'beetles_migrate_social_sign_up',
    CARIBOU_SSO_PROMOTION_EXPERIMENT: 'caribou_sso_promotion_experiment',
    CARIBOU_SSO_PROMOTION_ALLOCATIONS: 'caribou_sso_promotion_allocations',
} as const;

export const EXPERIMENTS = {
    LYNXES_IDENTIFICATION_RESET_PASSWORD_STEP: 4944,
    LYNXES_IDENTIFICATION_ILLUSTRATION_RIGHT: 4874,
    LYNXES_MODERN_HEADER: 4880,
    LYNXES_SEAMLESS_ONBOARDING_AND_ROUTING: 5010,
    CARIBOU_SSO_PROMOTION_EXPERIMENT: 5110,
} as const;
